import { useSyncExternalStore } from "react";

/**
 * DESIGN.md §Layout: "Breakpoint: <880px = phone. One breakpoint."
 *
 * This is the SAME range Tailwind's `max-phone:` variant covers (`screens.phone` is
 * `min-width: 880px` in tailwind.config.js, so `max-phone:` is `max-width: 879.98px`). Use the
 * CSS variant for anything CSS can express; use this hook only where the phone grammar needs a
 * different COMPONENT or BEHAVIOUR — the dock vs the tab bar, a side panel vs a draggable
 * bottom sheet. Both read one number, so CSS and JS can never disagree about what a phone is.
 */
export const PHONE_MEDIA_QUERY = "(max-width: 879.98px)";

function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(PHONE_MEDIA_QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia(PHONE_MEDIA_QUERY).matches;
}

/** Desktop on the server: there is no viewport to measure. */
function getServerSnapshot(): boolean {
  return false;
}

/**
 * True below 880px. Synchronous on the first render (matchMedia is a plain read), so the shell
 * mounts the right chrome in the first paint — no desktop dock flashing before the tab bar.
 */
export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
